import Layout from "../views/Layouts/DashboardLayout.vue";
import Dashboard from "../views/Dashboard/MainPage.vue";

export default {
  path: "/dashboard",
  component: Layout,
  children: [
    {
      path: "",
      name: "Dashboard",
      meta: {
        auth: true
      },
      component: Dashboard
    },
  ]
};
